import useSWR from "swr";
import { endpointsSpeckle } from "../actions/endpointsSpeckle";
import { fetcher } from "lib/actions/fetcher";
import { SpeckleWorkspaceModel } from "components/modules/UploadDialog/SpeckleImportWizard/types/SpeckleWorkspaceModel";

export function useSpeckleWorkspaces(speckleConnectedAccountId: number) {
  const {
    data: speckleWorkspaces,
    error,
    isLoading,
    mutate,
  } = useSWR<SpeckleWorkspaceModel[]>(
    speckleConnectedAccountId &&
      endpointsSpeckle.workspaces(speckleConnectedAccountId),
    fetcher,
  );

  async function refresh() {
    await mutate();
  }

  return {
    speckleWorkspaces,
    hasError: !!error,
    isLoading,
    refresh,
  };
}
